function Navbar() {
  var themeSrc = "/images/moon.svg";
  var themeClass = "theme light"
  if(localStorage.getItem('theme-teachquad') === 'dark') {
    document.body.classList.add('dark');
    themeSrc = '/images/sun.svg';
    themeClass = "theme dark";
  }
  function toggleMenu(e) {
    let menu = document.querySelector('#menu');
    let burger = document.querySelector('.burger');
    burger.classList.toggle('toggle');
    if(menu.classList.contains('show')) {
      menu.classList.remove('show');
      menu.classList.add('hidden');
      menu.style.top = '-100vh';
    } else {
      menu.classList.remove('hidden');
      menu.classList.add('show');
      menu.style.top = '70px';
    }
  }
  function changeTheme(e) {
    const theme = e.target.classList.contains("dark") ? "light" : "dark";
    document.body.classList.toggle("dark");
    if(theme === "dark") {
      e.target.classList.remove("light");
      e.target.classList.add("dark");
      e.target.setAttribute("src", "/images/sun.svg");
      localStorage.setItem("theme-teachquad", "dark");
    } else {
      e.target.classList.remove("dark");
      e.target.classList.add("light");
      e.target.setAttribute("src", "/images/moon.svg");
      localStorage.setItem("theme-teachquad", "light");
    }
  }
    return (
      <nav className="navBar">
        <div className="logoDiv">
            <img className="logoImg" src="/images/logo.png" alt="teach quad logo"/>
            <h3 className="logoText">TeachQuad</h3>
        </div>
        <ul className="menuList hidden" id="menu">
            <a className="menuListA" href="#home"><li className="menuItem">Home</li></a>
            <a className="menuListA" href="#about"><li className="menuItem">About</li></a>
            <a className="menuListA" href="#services"><li className="menuItem">Services</li></a>
            <a className="menuListA" href="#contact"><li className="menuItem">Contact</li></a>
            <li className="menuItem"><img onClick={changeTheme} className={themeClass} src={themeSrc} alt="Theme Toggle Button"/></li>
            <li className="menuItem"><button className="btn btn-login">Login</button></li>
        </ul>
        <div className="burger" onClick={toggleMenu}>
            <div className="line1"></div>
            <div className="line2"></div>
            <div className="line3"></div>
        </div>
      </nav>
    );
  }
  
  export default Navbar;
  